import styled from '@emotion/styled'
import Breakpoint from '../../Breakpoint'

const Title = styled.div`
    font-size: 2.6rem;
    font-family: 'Roboto Semi Bold';
    color: var(--primary-color);
    margin-bottom: 24px;

    @media (max-width: ${Breakpoint.TABLET_L}) {
        width: 100%;
        text-align: center;
    }
`

export default Title
